const page = (state = '', action) => {
  switch (action.type) {
    case 'STORE_PAGE': {
      const { name, extra } = action;

      return {
        name,
        extra,
      };
    }

    default:
      return state;
  }
};

export default page;
